import { useControlledSwr } from '@systemeio/util'
import { FUNNELS_API } from 'modules/funnels/api/funnels-api'
import { FunnelInterface } from 'modules/funnels/funnel/types/funnel-interface'
import { FunnelId } from 'modules/funnels/types/funnel-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export function useFunnel(id?: FunnelId) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, FunnelInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: funnel, mutate: mutateFunnel } = useControlledSwr(() => {
    if (user && id) {
      return [`${FUNNELS_API}/${id}`, RequestModuleEnum.Funnels]
    }
    return null
  }, fetcher)

  return { funnel, mutateFunnel }
}
